import { isTestEnvironment } from './environment.helpers';
import { meetsMinimumVersion } from './version.helpers';
import { MIN_AXON_VERSION_FOR_TIMELINE } from '../constants/versions.constants';
/**
 * Whether the participant event timeline is available for the given environment/org.
 *
 * Gated on both the environment kind (test envs only) and the org's Axon version: the timeline
 * reads notifications through the c_list_public_user_notifications route (AXONCONFIG-5248), which
 * only exists from MIN_AXON_VERSION_FOR_TIMELINE onward. Below that there is no backend to serve it.
 *
 * Shared by the entry point in participant_details.page.tsx and the direct-navigation guard in
 * participant_event_timeline.page.tsx so the two gates can never drift apart.
 */
export const isEventTimelineEnabled = (environment, org) => isTestEnvironment(environment) &&
    meetsMinimumVersion({
        currentVersion: org?.axon__version,
        minimumVersion: MIN_AXON_VERSION_FOR_TIMELINE,
    });
